import { SlidersVert } from "@layer/icons";
import type { Table } from "@tanstack/react-table";
import {
	Button,
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuTrigger,
} from "../../../components";

type StatusFilterProps<TData> = {
	table: Table<TData>;
	filterField: string;
};

const DataTableFilter = <TData,>({
	table,
	filterField,
}: StatusFilterProps<TData>) => {
	const column = table.getColumn(filterField);
	const allFilterValues = [
		...new Set(
			table
				.getPreFilteredRowModel()
				.rows.map((row) => row.getValue(filterField) as string),
		),
	];
	if (allFilterValues.length < 1) return null;
	const currentFilter = column?.getFilterValue() as string[] | undefined;
	const includedValues = new Set(currentFilter ?? allFilterValues);

	const handleFilterChange = (value: string) => {
		const updated = new Set(includedValues);

		if (includedValues.has(value)) {
			updated.delete(value);
		} else {
			updated.add(value);
		}
		column?.setFilterValue(
			updated.size === allFilterValues.length
				? undefined
				: Array.from(updated),
		);
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost">
					<SlidersVert className="h-4 w-4" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="min-w-[200px]">
				<DropdownMenuGroup>
					{allFilterValues.map((item) => (
						<DropdownMenuCheckboxItem
							key={item}
							className="capitalize"
							checked={includedValues.has(item)}
							onSelect={(e) => e.preventDefault()}
							onCheckedChange={() => handleFilterChange(item)}
						>
							{item}
						</DropdownMenuCheckboxItem>
					))}
				</DropdownMenuGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export { DataTableFilter };
